import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

function ChoiceModel({items, setModel, setSelectedData, setModelTop, setModelTopColor, setModelBottom}) {
	const [activeIndex, setActiveIndex] = useState(() => { });

	const updateModelData = (index, item) => {
		window.loadedObjects = {};
		if	(index === activeIndex) { // already selected
			return;
		}
		
		setActiveIndex(index);
		
		setSelectedData(prevState => ({
			...prevState,
			...item
		}));

		// Load Base Parts
		setModel(() => item.parts.main);
		setModelTop(() => item.parts.top.list[0]);
		setModelTopColor(() => item.parts.top.list[0].colors.list[0]);
		setModelBottom(() => item.parts.bottom.list[0]);
	}

	if (!items || !items.models) {
		return null;
	}
	return (
		<div className="choices">
			<ul>
				{items.models.map((item, index) => (
					<li key={index}>
						<a

							onClick={(e) => {
								e.preventDefault();
								updateModelData(index, item);
							}}
							className={classNames('preview decor-checkbox', { 'is-active': activeIndex === index })}
							href={item.model}
						>
							<picture className="preview__media">
								<img src={item.image} alt={item.name} />
							</picture>

							<div className="preview__content">
								<h6>{item.name}</h6>
							</div>
						</a>
					</li>
				))}
			</ul>
		</div >
	);
}

export default ChoiceModel;